module.exports = __webpack_public_path__ + "img/select.f4f3a878.svg";